import ApplicationSerializer from 'eflex/serializers/application';

export default class WieConfigWieSerializer extends ApplicationSerializer {
  attrs = {
    editorDefaults: {
      embedded: 'always',
    },
  };
}
